// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Home = (await import('./pages/Home')).Home;
    Components.LayoutContainer = (await import('./pages/LayoutContainer')).LayoutContainer;
    Components.SiteMapContainer = (await import('./pages/SiteMapContainer')).SiteMapContainer;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  siteMap: {
    name: 'SiteMapContainer',
    componentName: 'SiteMapContainer',
    chunk: () => import(
      './pages/SiteMapContainer'
    ),
    get component() {
      return ssr
        ? serverPages.SiteMapContainer
        : currentRouteName === 'SiteMapContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SiteMapContainer })));
    },
    path: '/:context?/:contentPV?/c/site_map',
    channel: null
  },
  siteMapB2C: {
    name: 'SiteMapContainer',
    componentName: 'SiteMapContainer',
    chunk: () => import(
      './pages/SiteMapContainer'
    ),
    get component() {
      return ssr
        ? serverPages.SiteMapContainer
        : currentRouteName === 'SiteMapContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SiteMapContainer })));
    },
    path: '/:context?/:contentPV?/c/site_map-b2c',
    channel: null
  },
  siteMapB2B: {
    name: 'SiteMapContainer',
    componentName: 'SiteMapContainer',
    chunk: () => import(
      './pages/SiteMapContainer'
    ),
    get component() {
      return ssr
        ? serverPages.SiteMapContainer
        : currentRouteName === 'SiteMapContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SiteMapContainer })));
    },
    path: '/:context?/:contentPV?/c/site_map-b2b',
    channel: null
  },
  layoutContainer: {
    name: 'LayoutContainer',
    componentName: 'LayoutContainer',
    chunk: () => import(
      './pages/LayoutContainer'
    ),
    get component() {
      return ssr
        ? serverPages.LayoutContainer
        : currentRouteName === 'LayoutContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LayoutContainer })));
    },
    path: '/:context?/:contentPV?/c/:slug',
    channel: null
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import(
      './pages/Home'
    ),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  }
});
